import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { useFacility } from "@/lib/facility/facility";
import { useCan } from "@/lib/policy";
import { guardRoute } from "@/lib/policy/route-guard";
import { CrmCatalogCard } from "./-components/billing/crm-catalog-card";
import { ReferralSourceCard } from "./-components/crm/referral-source-card";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";

export const Route = createFileRoute("/_authenticated/_administration/settings/lead-fields")({
  beforeLoad: ({ context }) => guardRoute(context.me, "crm-lead-fields"),
  component: LeadFieldSettings,
});

/** Per building, never deleted: an answer already on a lead is switched off, so the lead keeps its
 * history. */
function LeadFieldSettings() {
  const { facilityId } = useFacility();
  const realFacility = facilityId === "all" ? null : facilityId;
  const canManage = useCan("crm:manage");
  const shared = { facilityId, realFacility, canManage };

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Lead fields"
        meta="The answers the lead form offers: where an enquiry came from, how you reached the family, and why it was won or lost."
      />

      {canManage && !realFacility ? (
        <OneBuildingCard
          prompt={"Every building's answers are listed below. To add one, choose its building."}
        />
      ) : null}

      <CrmCatalogCard
        {...shared}
        catalog="sourceTypes"
        title="Source types"
        noun="source type"
        purpose="Add one to group lead sources in the reports, like Hospital discharge."
        placeholder="Hospital discharge"
      />
      <ReferralSourceCard {...shared} />
      <CrmCatalogCard
        {...shared}
        catalog="contactMethods"
        title="Contact methods"
        noun="contact method"
        purpose="Add one to record how staff reached a lead, like Telephone."
        placeholder="Telephone"
      />
      <CrmCatalogCard
        {...shared}
        catalog="lostReasons"
        title="Lost reasons"
        noun="lost reason"
        purpose="Add one to record why a lead did not move in, like Chose another community."
        placeholder="Chose another community"
      />
      <CrmCatalogCard
        {...shared}
        catalog="wonReasons"
        title="Won reasons"
        noun="won reason"
        purpose="Add one to record why a lead chose you, like Recommended by family."
        placeholder="Recommended by family"
      />
    </div>
  );
}
